<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-tabs [(ttSelectedId)]="selectedBgBatchPurchaseLinesBs">
                <tt-tab ttId="0" ttLabel="batchdelivery_gb_simple"></tt-tab>
                <tt-tab ttId="1" ttLabel="batchdelivery_gb_details"></tt-tab>
            </tt-tabs>

            <div *ngFor="let item of inputListPurchaseLines">
                <label *ngIf="item.orderby > ''" class="checklist-h1 col-xs-12">{{item.orderby}}</label>
            </div>

            <div [hidden]="selectedBgBatchPurchaseLinesBs !== '0'">
                <ng-container *ngTemplateOutlet="basicInfo"></ng-container>
            </div>

            <div [hidden]="selectedBgBatchPurchaseLinesBs !== '1'">
                <ng-container *ngTemplateOutlet="economics"></ng-container>
            </div>

            <tt-button-save *ngIf="setting.show_save_button === '1'" ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 col-md-6 p-5" *ngFor="let item of inputListPurchaseLines">
            <label *ngIf="item.orderby > ''" class="checklist-h1 col-xs-12">{{item.orderby}}</label>
        </div>

        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="batchdelivery_gb_simple">
                <ng-container *ngTemplateOutlet="basicInfo"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="batchdelivery_gb_details">
                <ng-container *ngTemplateOutlet="economics"></ng-container>
            </tt-card>
        </div>

        <tt-card class="col-xs-12 col-md-6 p-5" *ngIf="setting.show_save_button === '1'">
            <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </tt-card>
    </div>
</tt-page>

<ng-template #basicInfo>
    <ng-container *ngIf="!!inputListPurchaseLines">
        <div *ngFor="let item of inputListPurchaseLines">
            <tt-input ttLabel="suppliers_batchno" [(ttModel)]="item.suppliers_batchno"></tt-input>
            <tt-date ttLabel="best_before_date" [(ttModel)]="item.best_before_date"></tt-date>
            <tt-input-number ttLabel="quantity" [ttModel]="item.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input ttLabel="stockbatch_keyno" [ttModel]="item.stockbatch_keyno" ttReadonly></tt-input>
        </div>
    </ng-container>
</ng-template>

<ng-template #economics>
    <ng-container *ngIf="!!inputListPurchaseLines">
        <div *ngFor="let item of inputListPurchaseLines">
            <tt-input-number ttLabel="quantity" [ttModel]="item.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="purchprice_locval" [ttModel]="item.purchprice_locval" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="freight_EU" [ttModel]="item.freight_EU" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="freight_ex_EU" [ttModel]="item.freight_ex_EU" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="customs_eu" [ttModel]="item.customs_eu" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="customs_ex_eu" [ttModel]="item.customs_ex_eu" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="divcost" [ttModel]="item.divcost" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="price_locval" [ttModel]="item.price_locval" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="amount_locval" [ttModel]="item.amount_locval" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="purchprice_invval" [ttModel]="item.purchprice_invval" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="amount_invval" [ttModel]="item.amount_invval" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input ttLabel="country_id_origin" [ttModel]="item.country_id_origin" ttReadonly></tt-input>
            <tt-input ttLabel="valuta_id" [ttModel]="item.valuta_id" ttReadonly></tt-input>
        </div>
    </ng-container>
</ng-template>
